<div class="container">  
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="onTabChange($event)"
  >
  <mat-tab label="Formularios de Inspección">
    <div class="container mt-4">
    <div class="container-toggle">
        <mat-slide-toggle class="toggle" (change)="changeToggle($event)" [(ngModel)]="isChecked">{{labelToggle}}</mat-slide-toggle>
      </div>

    <data-table
      [title]='titleIF'
      [columns]="columnsIF"
      [url]="EndpointDictionary.InspectionForm.INSPECTION_FORM_TABLE"
      [configuration]="configurationIF"
      [reloadTable]="reloadTableIF"
      [params]="paramsInspectionForm"
      [headerFilters]="headerFilters"
      [headerFileXlsm]="headerFileXlsm"
      (add)="addIF($event)"
      (edit)="editIF($event)"
      (delete)="deleteIF($event)"
      (active)="inactivateOrActiveInspectionForms($event, !isChecked)"
      >
    </data-table>
  </div>
  </mat-tab>

  <mat-tab *ngIf="currentState == stateTab.DETAIL && selected.value == 1" label="{{ label }}">
    <div class="W-100 mt-3">
      <app-inspection-form-detail
      [inspectionForm]="inspectionForm"
      (completeForm)="completeCreateForm()"
      (formChanged)="onFormChanged($event)">
      </app-inspection-form-detail>
    </div>
  </mat-tab>

  </mat-tab-group>
  </div>